// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cz2.cz2 .cz3__info-tip{margin-left:3px;width:16px;height:16px;border:none;border-radius:8px;vertical-align:-2px}#cz2.cz2 .cz3__info-tip:focus{outline:2px solid #000;outline-offset:2px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
